<template>
    <div>
        <w-flex class="justify-end mb3">
            <w-card class="xs3">
                <w-input type="month" v-model="tarikhMula"
                    >Tarikh Permulaan</w-input
                >
            </w-card>

            <w-card class="xs3">
                <w-input type="month" v-model="tarikhAkhir"
                    >Tarikh Pengakhiran</w-input
                >
            </w-card>

            <w-button
                bg-color="primary"
                @click="fetchData()"
                class="pl-3"
            >
                Tapis</w-button
            >
        </w-flex>
        
        
        <w-flex class="row">
            <w-card class="mb3 xs12">
                <div class="dashboard-title">
                    {{ title }}
                </div>
                <div v-if="loading" class="d-flex justify-center">
                    <w-spinner fade/>
                </div>
                <fusioncharts
                    v-else
                    :type="chart.type"
                    :width="chart.width"
                    :height="chart.height"
                    :dataformat="chart.dataFormat"
                    :dataSource="chart.dataSource"
                >
                </fusioncharts>
            </w-card>
        </w-flex>
    </div>
</template>
<script>
import moment from 'moment'
export default {
    data() {
        return {
            title: "PERBANDINGAN KUTIPAN",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            render: true,
            loading: false,
            tarikhMula: moment().format('YYYY-01'),
            tarikhAkhir: moment().format('YYYY-MM'),
            chart: {
                type: "mscolumn2d",
                renderAt: "chart-container",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {}
            },
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            this.loading = true;
            await axios.get(`${this.apiBaseUrl}/dashboard/kutipan-mengikut-jabatan-dan-julat`,{
                params: {
                    tarikh_mula: this.tarikhMula,
                    tarikh_akhir: this.tarikhAkhir,
                }
            })
            .then(e => {
                const {data} = e
                this.chart.dataSource = data
                this.forceRerender()
            })
            .finally(() => {
                this.loading = false;
            })
        },
        async forceRerender(){
            this.render = false
            await this.$nextTick()
            this.render = true
        }
    },
};
</script>
<style>
.dashboard-title {
    font-size: 17px;
    font-weight: bold;
    text-transform: uppercase;
}

path:hover,
circle:hover {
    stroke: #6666ff !important;
    stroke-width: 2px;
    stroke-linejoin: round;
    fill: #6666ff !important;
    cursor: pointer;
}
</style>
